import Logo from './Logo';

import styles from './index.module.css';

interface Props {
  left?: React.ReactNode;
  right?: React.ReactNode;
  directory?: boolean;
}

const BaseNavBar: React.FC<Props> = ({
  left = null,
  right = null,
  directory = false,
}) => {
  return (
    <div className={styles.HeaderWrapper}>
      <div className={styles.Header}>
        {left}
        <Logo />
        {right}
      </div>
      {directory ? (
        <div className={styles.DirectoryDivider} />
      ) : (
        <div className={styles.Divider} />
      )}
    </div>
  );
};

export default BaseNavBar;
